import { useEffect, useState } from 'react';
import { themeService, ThemeSettings } from '../services/themeService';
import { settingsStorage } from '../services/settingsStorage';
import { get } from 'idb-keyval';

export const useTheme = () => {
  const [settings, setSettings] = useState<ThemeSettings>({ templateId: 'default' });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadTheme = async () => {
      try {
        const storedSettings = await settingsStorage.getThemeSettings();

        if (storedSettings.background && storedSettings.background.type !== 'none') {
          const bgType = storedSettings.background.type;
          const storageKey = `theme-background-${bgType}`;
          const bgData = await get(storageKey);

          if (bgData) {
            storedSettings.background.data = bgData as string;
          }
        }

        setSettings(storedSettings);
        themeService.applyTheme(storedSettings);
      } catch (error) {
        themeService.applyTheme({ templateId: 'default' });
      } finally {
        setIsLoaded(true);
      }
    };

    loadTheme();
  }, []);

  const saveTheme = async (newSettings: ThemeSettings) => {
    try {
      await settingsStorage.saveThemeSettings(newSettings);
      setSettings(newSettings);
      themeService.applyTheme(newSettings);
    } catch (error) {
      throw error;
    }
  };

  return {
    settings,
    saveTheme,
    isLoaded,
  };
};
